import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function TextMetadataQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 4.25C2 3.97386 2.22386 3.75 2.5 3.75H13.5C13.7761 3.75 14 3.97386 14 4.25C14 4.52614 13.7761 4.75 13.5 4.75H2.5C2.22386 4.75 2 4.52614 2 4.25Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 6.75C3.5 6.47386 3.72386 6.25 4 6.25H12C12.2761 6.25 12.5 6.47386 12.5 6.75C12.5 7.02614 12.2761 7.25 12 7.25H4C3.72386 7.25 3.5 7.02614 3.5 6.75Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 9.25C2 8.97386 2.22386 8.75 2.5 8.75H13.5C13.7761 8.75 14 8.97386 14 9.25C14 9.52614 13.7761 9.75 13.5 9.75H2.5C2.22386 9.75 2 9.52614 2 9.25Z'
        fill='#3E8FFA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 11.75C3.5 11.4739 3.72386 11.25 4 11.25H12C12.2761 11.25 12.5 11.4739 12.5 11.75C12.5 12.0261 12.2761 12.25 12 12.25H4C3.72386 12.25 3.5 12.0261 3.5 11.75Z'
        fill='#3E8FFA'
      />
    </SvgIcon>
  );
}
